/**
 * Labstep
 *
 * @module components/AccessKey/Form/ShowEdit/Name
 * @desc Form to Edit AccessKey name
 */

import { accessKeyFieldName } from 'labstep-web/components/AccessKey/Form/fields';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import { ShowEdit } from 'labstep-web/core/Form/ShowEdit';
import { AccessKey } from 'labstep-web/models/access-key.model';
import omit from 'lodash/omit';
import type React from 'react';
import type { AccessKeyTableCellProps } from './types';

export const AccessKeyFormShowEditName: React.FC<
  AccessKeyTableCellProps
> = ({ accessKeyItem }) => (
  <ShowEdit
    entityName={AccessKey.entityName}
    entity={accessKeyItem}
    field={
      omit(accessKeyFieldName, [
        'fieldExplainer',
        'fieldLabel',
      ]) as FieldWithoutActionProps
    }
    canEdit
  >
    {accessKeyItem.name}
  </ShowEdit>
);
